<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Incoming Transfers</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" class="mt-4">
            <v-text-field dense label="Search" v-model="search"></v-text-field>
          </v-col>

          <v-divider></v-divider>

          <v-col cols="12" class="subtitle-2 text--primary">
            <v-data-table
              :mobile-breakpoint="zeroValue"
              :headers="headers"
              :items="reportData"
              :search="search"
            >
              <!-- date template -->
              <template v-slot:item.date="{ item }">{{ item.date | date}}</template>
              <!-- end of date template -->

              <!-- date template -->
              <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end of date template -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn text color="accent" :to="`/incoming-transfers/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> Details / Receiving
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <snackbar ref="snackbar"></snackbar>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      customers: [],
      stores: [],
      users: [],
      reportData: [],
      headers: [
        { text: "To: Customer", value: "customer.Name" },
        { text: "From", value: "fromStore.Name" },
        { text: "To: Branch / Store", value: "toStore.Name" },
        { text: "Total", value: "DocTotal" },
        { text: "Date", value: "date" },
        { text: "Transferred By", value: "user.name" },
        { text: "Action", value: "action" }
      ]
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getDrafts() {
      const url = "/incoming-transfers";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getDrafts();
  }
};
</script>
  
  <style lang="scss" scoped>
</style>